module.exports = __webpack_public_path__ + "media/images/icon/chevron-left-black-8b115d0bf14b5753a953a01c3c9f2fab.svg";